export default __webpack_public_path__ + "static/vr-6e4bf110adb5a7e66619818bc72b8fbb.svg";